import React from 'react';

export const FirstNonEmptyChild: React.FC<React.PropsWithChildren> = ({ children }) => {
  const firstNonEmptyChild = React.Children.toArray(children).filter(Boolean).shift();
  return <>{firstNonEmptyChild ?? null}</>;
};
